import { render } from "./BlogHomePage.vue?vue&type=template&id=27f9592e"
import script from "./BlogHomePage.vue?vue&type=script&lang=js"
export * from "./BlogHomePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__